import {Spin, Flex} from "antd"
import {LoadingOutlined} from "@ant-design/icons"

const ComponentFillGenericLoader = () => {
    return (
        <Flex align="middle" justify="center" gap="middle">
            <Spin indicator={<LoadingOutlined spin />} size="large" fullscreen/>
        </Flex>
    )
}

export default ComponentFillGenericLoader;